import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import BadgeList from '../../../../common/BadgeList';
import { freeOfChargeRulePropType } from '../proptypes/FreeOfChargeRuleProptypes';

const FreeOfChargeRuleBasicInformationResource = ({ freeOfChargeRule }) => {
  const { id, active, userList } = freeOfChargeRule || {};

  const users = (userList || []).map((user) => ({
    text: user.fullName,
    color: 'info',
  }));

  return (
    <>
      <ResourceProperty label="ID:">{id || '-'}</ResourceProperty>

      <ResourceProperty label="Activo:">
        {active ? 'Sí' : 'No'}
      </ResourceProperty>

      <ResourceProperty label="Usuarios:">
        <BadgeList textArray={users} />
      </ResourceProperty>
    </>
  );
};

FreeOfChargeRuleBasicInformationResource.propTypes = {
  freeOfChargeRule: freeOfChargeRulePropType,
};

FreeOfChargeRuleBasicInformationResource.defaultProps = {
  freeOfChargeRule: null,
};

export default FreeOfChargeRuleBasicInformationResource;
